import {
    TextField,
    Form,
    InlineBanner,
    Button,
    IconChevronLeft,
    Text,
    toast
} from '@7shifts/sous-chef';
import { Navigate, useSearchParams, useNavigate } from 'react-router-dom';
import { __ } from 'i18n';
import { getSchema } from './schema';
import { useFormik } from 'formik';
import { useAuthContext } from '../../../../contexts/AuthContext';
import { resetPassword } from 'api/accountApi';
import { useState } from 'react';

const ForgotPasswordForm = () => {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const wasLoggedOut = params.get('logged_out');
    const urlReturn = params.get('urlReturn');
    const [isResetPasswordSuccess, setIsResetPasswordSuccess] = useState(false);
    const { isAuth } = useAuthContext();

    const formik = useFormik({
        initialValues: {
            email: ''
        },
        validationSchema: getSchema(),
        onSubmit: (formValues, { setSubmitting }) => {
            setSubmitting(true);
            resetPassword(formValues.email)
                .then(() => {
                    setIsResetPasswordSuccess(true);
                    toast(__('loginPage.resetPasswordSuccess'));
                })
                .finally(() => setSubmitting(false));
        }
    });

    if (isAuth) {
        if (urlReturn) {
            return <Navigate to={urlReturn} />;
        }
        return <Navigate to="/dashboard" />;
    }

    return (
        <Form wide formik={formik}>
            {wasLoggedOut && (
                <InlineBanner theme="success">
                    {__('loginPage.youHaveBeenLoggedOut')}
                </InlineBanner>
            )}
            {!isResetPasswordSuccess && (
                <Text alignment="center" as="h4">
                    {__('loginPage.forgotPasswordDescription')}
                </Text>)}
            {!isResetPasswordSuccess && (<TextField
                name="email"
                label={__('loginPage.email')}
                placeholder={__('loginPage.typeEmail')}
            />)}
            {!isResetPasswordSuccess && (
                <Button
                    type="submit"
                    theme="primary"
                    size="full-width"
                    loading={formik.isSubmitting}
                >
                    {__('loginPage.sendResetLink')}
                </Button>
            )}
            <Button
                onClick={() => navigate('/login')}
                theme="link-primary"
                size="full-width"
                loading={formik.isSubmitting}
            >
                <IconChevronLeft />
                {__('loginPage.backToLogin')}
            </Button>
        </Form>
    );
};

export default ForgotPasswordForm;
